import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const Calendar = lazy(() => import("../Components/ProfilesType/Mentor/Calendar/Calendar"));
const MentorHome = lazy(() => import("../Components/ProfilesType/Mentor/MentorHome/MentorHome"));
const ProfileSetup = lazy(() => import("../Components/ProfilesType/Mentor/ProfileSetup/ProfileSetup"));
const Queue = lazy(() => import("../Components/ProfilesType/Mentor/Queue/Queue"));
const Payments = lazy(() => import("../Components/ProfilesType/Mentor/Payments/Payments"));
const History = lazy(() => import("../Components/ProfilesType/Mentor/History/History"));

export const mentorRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><MentorHome /></Suspense>,
    },
    {
        path : "queue",
        element : <Suspense fallback={<GlobalLoading />}><Queue/></Suspense>
    },
    {
        path : "calendar",
        element : <Suspense fallback={<GlobalLoading />}><Calendar/></Suspense>
    },
    {
        path : "payments",
        element : <Suspense fallback={<GlobalLoading />}><Payments/></Suspense>
    },
    {
        path : "history",
        element : <Suspense fallback={<GlobalLoading />}><History/></Suspense>
    },
    {
        path : "profile-setup",
        element : <Suspense fallback={<GlobalLoading />}><ProfileSetup/></Suspense>
    }
]